import React from 'react'
import { connect } from "react-redux"
import withStyles from '@material-ui/core/styles/withStyles'
import { CollateralStyles } from '../../CollateralStyles'
import { useTranslation } from 'react-i18next'
import DataTable from 'react-data-table-component'
import { Container } from '@material-ui/core'
import { customStyleSecondary } from '../../../common/CommonStyles'

const Tramit = ({ classes, ...props }) => {
    const { t } = useTranslation()

    const paginationOptions = { rowsPerPageText: t('commonMessages.rowsPerPage'), rangeSeparatorText: t('common.to'), selectAllRowsItem: true, selectAllRowsItemText: t('common.all') }

    const columns = [
        {
            name: t('collateralDetails.tramit'),
            selector: 'procedureDescription',
            width: '500px',
            sortable: true,
            cell: row => row.procedureDescription
        },
        {
            name: t('common.state'),
            selector: 'stateName',
            sortable: true,
            cell: row => row.stateName
        },
        {
            name: t('collateralDetails.provideerPayment'),
            selector: 'promoterCost',
            sortable: true,
            cell: row => row.promoterCost
        }
    ]

    return (
        <div>
            <Container className={classes.generalBorder}>
                <br />
                <DataTable
                    columns={columns}
                    customStyles={customStyleSecondary}
                    data={props.workDetail[0].details}
                    highlightOnHover
                    defaultSortField="subStageDate"
                    dense
                    noHeader
                    pointerOnHover
                    pagination
                    paginationComponentOptions={paginationOptions}
                />
            </Container>
        </div>
    )
}

const mapStateToProps = state => ({
    dashboardItems: state.CollateralReducer.list,
    userProfile: state.UserProfileReducer.list,
    userlogin: state.LoginReducer.list,
    isUserAuthenticated: state.LoginReducer.isAuthenticated,
    userToken: state.LoginReducer.token,
    userLanguage: state.LoginReducer.language
})

export default connect(mapStateToProps)(withStyles(CollateralStyles)(Tramit))
